import GridExpandableAtom from '@components/atom/grid/gridExpandable';
import { useCallback, useEffect, useState } from 'react';
import { TeamMember } from '@classes/options/grid/account/teamGridOption';
import { teamManagerViewType } from '@models/manager/account/account';
import ExpandedComponent from './expandedComponent';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { setViewState } from '@reducers/account/teamSlice';
import { fetchMemberInfoList } from '@reducers/account/thunks/teamThunk';

const TeamList = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { teamInfoList } = useSelector(({ team }: RootState) => team);

  const [gridChartOption, setGridChartOption] = useState(null);

  useEffect(() => {
    if (teamInfoList) {
      setGridChartOption(new TeamMember().teamList(teamInfoList, clickedTeamName));
    }
  }, [teamInfoList]);

  const clickedTeamName = useCallback(
    (rowObj) => {
      dispatch(fetchMemberInfoList({ ...rowObj }));
      dispatch(setViewState({ view: teamManagerViewType.memberList }));
    },
    [dispatch, setViewState, fetchMemberInfoList, teamManagerViewType]
  );

  return (
    <div className="tb-basic-wrap">
      <GridExpandableAtom {...gridChartOption} height={'450px'} ExpandedComponent={ExpandedComponent} />
    </div>
  );
};

export default TeamList;
